<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="cancel"
    :visible.sync="dialog"
    :show-close="false"
    custom-class="custom-announcement-dialog"
    width="1100px">
    <section class="announcement">
      <!-- 正文使用正常文档流，避免内容变更后因绝对定位产生重叠。 -->
      <article class="announcement__content">
        <h2 class="announcement__title">
          <span>关于不法分子冒用我司名义开设虚假企业微信账号的</span>
          <span>严正声明</span>
        </h2>

        <p class="announcement__paragraph">近期，重庆隆携小额贷款有限公司（以下简称“我司”）发现有不法分子擅自冒用我司名义，伪造我司企业微信账号，并假借我司身份通过该虚假渠道开展信贷业务、诱导公众添加好友或拉入社群等违规活动。该仿冒侵权行为不仅严重损害了我司的声誉与合法权益，更极易误导广大群众，引发公众财产损失、信息泄露等风险，涉嫌违法违规。为维护我司及社会公众的合法权益，现严正声明如下：</p>
        <p class="announcement__paragraph"><span class="announcement__section-title">一、 我司官方渠道唯一性声明。</span>重庆隆携小额贷款有限公司的官方网站为 <a href="https://www.longxie.net" target="_blank" rel="noopener noreferrer">www.longxie.net</a> ；官方认证企业微信ID为 v5bbf3d26652 和 v6e364c01aaa。凡非通过上述官方渠道公示或认证的企业微信账号，均为伪造、仿冒的非法账号，与我司无任何关联。</p>
        <p class="announcement__paragraph"><span class="announcement__section-title">二、 冒名行为与我司无关。</span>任何机构或个人未经我司正式书面授权冒用我司名称、品牌标识，通过伪造的企业微信、微信群或其他社交平台发布的业务信息、贷款承诺及收费要求，均属非法行为，与我司无任何关联。我司对此类行为不承担任何法律责任。</p>
        <p class="announcement__paragraph"><span class="announcement__section-title">三、 严正警告与追责。</span>对于冒用我司名义、伪造企业微信进行非法活动的机构或个人，我司正告其立即停止一切侵权行为。我司已着手收集相关证据，并保留通过法律途径追究其侵权及法律责任的权利。</p>
        <p class="announcement__paragraph"><span class="announcement__section-title">四、 公众风险提示。</span>在此郑重提醒广大社会公众、合作伙伴及客户，务必提高风险甄别意识，严格核验对接渠道真伪。切勿轻信非官方企业微信发布的贷款信息或业务合作，切勿向不明账户转账，坚决拒绝支付所谓手续费、保证金、服务费等各类名目费用，切实守护自身财产安全。若您无法辨别对接账号、业务信息的真伪，或已因上述虚假账号遭受损失，请立即拨打我司官方电话4001003066进行确认，或直接向公安机关报案维权。</p>
        <p class="announcement__paragraph announcement__conclusion">特此声明。</p>

        <footer class="announcement__signature">
          <span>重庆隆携小额贷款有限公司</span>
          <span>2026年8月28日</span>
        </footer>
      </article>

      <button
        type="button"
        class="announcement__close"
        aria-label="关闭公告"
        @click="closeClick">
        <i class="el-icon-circle-close" aria-hidden="true"></i>
      </button>
    </section>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialog: true,
    }
  },
  methods: {
    closeClick() {
      this.cancel()
    },
    cancel() {
      this.resetForm()
    },
    resetForm() {
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
/* 弹窗挂载到 body，使用专属类限制 Element UI 样式覆盖范围。 */
.custom-announcement-dialog {
  position: relative;
  max-width: calc(100vw - 32px);
  margin-top: 5vh !important;
  background-color: transparent;
  box-shadow: none;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    line-height: normal;
  }
}
</style>

<style lang="scss" scoped>
.announcement {
  position: relative;
  width: 100%;
  color: #303133;
  text-align: left;
  letter-spacing: 0;
  background-image: url('./img/公告背景.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;

  &::before {
    display: block;
    padding-top: 56.26%;
    content: '';
  }

  &__content {
    position: absolute;
    top: 15%;
    right: 7.5%;
    bottom: 19%;
    left: 7.5%;
    box-sizing: border-box;
    padding-right: 6px;
    overflow-y: auto;
  }

  &__title {
    margin: 0 0 8px;
    color: #202124;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.35;
    text-align: center;

    span {
      display: block;
    }
  }

  &__paragraph {
    margin: 0 0 4px;
    font-size: 14px;
    line-height: 1.5;
    text-align: justify;
    text-indent: 2em;
  }

  &__section-title {
    font-weight: bold;
  }

  &__conclusion {
    margin-bottom: 0;
  }

  &__signature {
    padding-right: 2em;
    font-size: 14px;
    line-height: 1.5;
    text-align: right;

    span {
      display: block;
    }
  }

  &__close {
    position: absolute;
    top: -20px;
    right: -20px;
    z-index: 1;
    width: 40px;
    height: 40px;
    padding: 0;
    color: #fff;
    font-size: 35px;
    line-height: 1;
    cursor: pointer;
    background: transparent;
    border: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/customAnnouncement/index.vue